export default __webpack_public_path__ + "static/media/arrow-long-right.09b6c008.svg";